module.exports = __webpack_public_path__ + "static/media/larry3.f8aa9175.mp3";